import React, { useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';
import Button from '../components/shared/buttons/Button';
import ButtonLoader from '../components/shared/loaders/ButtonLoader';
import { loginAction } from '../redux/actions/authActions';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(loading);
    const credentials = new FormData();
    credentials.append('username', event.target.username.value);
    credentials.append('password', event.target.password.value);
    await dispatch(loginAction(credentials, navigate));
    setLoading(false);
  };

  const loginError = useSelector((state) => state.auth?.loginError);

  return (
    <section className="bg-white h-screen">
      <div className="flex flex-col items-center justify-center sm:px-6 sm:pt-14">
        <div className="h-full w-full text-center max-w-md bg-white lg:border">
          <div className="p-6 space-y-6">
            <div className="flex justify-center items-center my-6">
              <img
                className="w-10 h-10 mr-2 lg:mr-4 bg-gradient-to-tr from-contrast1 to-contrast2
                        text-text1 rounded-3xl p-2"
                src={require('../assets/automako_logo.png')}
                alt="logo"
              />
              <span className={'text-bg3 text-3xl font-extrabold'}>AUTO</span>
              <span className="text-contrast2 text-3xl font-extrabold">MAKO</span>
            </div>
            <h1 className="text-xl leading-tight tracking-tight">Вхід в акаунт</h1>
            <form className="flex flex-col gap-4 text-left" onSubmit={handleSubmit}>
              <div>
                <label htmlFor="login" className="input-label">
                  Логін
                </label>
                <input
                  type="login"
                  id="username"
                  name="username"
                  value={userName}
                  onChange={(event) => setUserName(event.target.value)}
                  className={twMerge('input p-3')}
                  placeholder="Введіть логін"
                  autoComplete="off"
                  required
                />
              </div>
              <div>
                <label htmlFor="password" className="input-label">
                  Пароль
                </label>
                <div className="relative">
                  <div
                    className="absolute inset-y-0 right-4 flex items-center pl-3 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <AiFillEyeInvisible size="20" className="text-font3" />
                    ) : (
                      <AiFillEye size="20" className="text-font3" />
                    )}
                  </div>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    id="password"
                    placeholder="Введіть пароль"
                    autoComplete="off"
                    className={twMerge('input p-3')}
                    required=""
                  />
                </div>
              </div>
              <Button type="submit" variant={'primary'} disabled={loading} className="w-full mt-6 text-sm py-2.5">
                <div className="flex justify-center w-full items-center">{loading ? <ButtonLoader /> : 'Вхід'}</div>
              </Button>
              <div className="mb-2 text-center">
                {loginError && <span className="text-contrast1">{loginError}</span>}
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
